import Box from "@mui/material/Box";
import { useState } from "react";
import MonthlySummary from "../components/MonthlySummary";
import Calendar from "../components/Calendar";
import TransactionMenu from "../components/TransactionMenu";
import TransactionForm from "../components/TransactionForm";
import { Transaction, User } from "../types";
import { RootState } from "../store/store";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedTransaction } from "../store/appSlice";

interface HomeProps {
  isFetching: boolean;
}

const Home = ({ isFetching }: HomeProps) => {
  // console.log("Home:transactions: ", transactions);
  const {
    isMobile,
    transactions,
    selectedTransaction,
    isLoggedIn,
    currentDay,
  } = useSelector((state: RootState) => state.app);
  const dispatch = useDispatch();
  const [isEntryDrawerOpen, setIsEntryDrawerOpen] = useState<boolean>(false);
  const [isDailyListWindowView, setIsDailyListWindowView] = useState(false);
  const [isInputFormDialog, setIsInputFormDialog] = useState(false);

  const dailyTransactions = transactions.filter((tr) => {
    return tr.date === currentDay;
  });

  const closeForm = () => {
    if (isMobile) {
      setIsInputFormDialog(false);
    } else {
      setIsEntryDrawerOpen(!isEntryDrawerOpen);
    }
  };
  const handleAddTransactionForm = () => {
    if (isMobile) {
      // フォームクリア
      dispatch(setSelectedTransaction(null));

      setIsInputFormDialog(true);
    } else {
      // 入力フォームがOpen状態かつ選択取引がある場合フォームクリア(PC版)
      if (isEntryDrawerOpen && selectedTransaction) {
        dispatch(setSelectedTransaction(null));
      } else {
        setIsEntryDrawerOpen(!isEntryDrawerOpen);
      }
    }
  };

  const handleSelectTransaction = (transaction: Transaction) => {
    const selected = dailyTransactions.find((tr) => tr.id === transaction.id);
    // console.log("home:selected:", selected);
    dispatch(setSelectedTransaction(selected || null));

    if (isMobile) {
      setIsInputFormDialog(true);
    } else {
      // 取引選択したらフォームを必ず開いた状態する。。
      setIsEntryDrawerOpen(true);
    }
  };

  const handleDailyListWindowView = () => {
    setIsDailyListWindowView(!isDailyListWindowView);
  };

  const handleInputFormDialog = () => {
    console.log("handleInputFormDialog");
    setIsInputFormDialog(!isInputFormDialog);
  };

  if (!isLoggedIn || isFetching) {
    return (
      <Box sx={{ display: "flex" }}>
        {/* 左側用 */}
        <Box sx={{ flexGrow: 1, bgcolor: "white", p: 1 }}>
          <MonthlySummary />
          <Calendar dailyListWindowView={handleDailyListWindowView} />
        </Box>
        <Box>
          <TransactionMenu
            dailyTransactions={[]}
            onAddTransactionForm={handleAddTransactionForm}
            onSelectTransaction={handleSelectTransaction}
            isDailyListWindowView={isDailyListWindowView}
            dailyListWindowView={handleDailyListWindowView}
          />
          <TransactionForm
            isEntryDrawerOpen={isEntryDrawerOpen}
            onCloseForm={closeForm}
            isInputFormDialog={isInputFormDialog}
            onInputFormDialog={handleInputFormDialog}
          />
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex" }}>
      {/* 左側用 */}
      <Box sx={{ flexGrow: 1, bgcolor: "white", p: 1 }}>
        <MonthlySummary />
        <Calendar dailyListWindowView={handleDailyListWindowView} />
      </Box>

      {/* 右側用 */}
      <Box>
        <TransactionMenu
          dailyTransactions={dailyTransactions}
          onAddTransactionForm={handleAddTransactionForm}
          onSelectTransaction={handleSelectTransaction}
          isDailyListWindowView={isDailyListWindowView}
          dailyListWindowView={handleDailyListWindowView}
        />
        <TransactionForm
          isEntryDrawerOpen={isEntryDrawerOpen}
          onCloseForm={closeForm}
          isInputFormDialog={isInputFormDialog}
          onInputFormDialog={handleInputFormDialog}
        />
      </Box>
    </Box>
  );
};

export default Home;
